import { Component, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private readonly platformId = inject(PLATFORM_ID);

  readonly contactEmail = 'yatendra.rajput@chevron.com';
  readonly mailtoLink = `mailto:${this.contactEmail}`;
  readonly currentYear = new Date().getFullYear();
  readonly buildDate = this.getBuildDate();

  private getBuildDate(): string {
    const formatOptions: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    // `document` only exists in the browser; fall back to "now" during SSR.
    if (isPlatformBrowser(this.platformId)) {
      const parsedDate = new Date(document.lastModified);
      if (!Number.isNaN(parsedDate.getTime())) {
        return parsedDate.toLocaleDateString('en-US', formatOptions);
      }
    }

    return new Date().toLocaleDateString('en-US', formatOptions);
  }
}
